import * as UI from "@iyk/ui"
import { Data } from "effect"

const make = Data.case<Config>()

export const config = make({
  appId: "tom-grennan",
  general: {
    email: "tomgrennan@iyk.app",
    name: "Tom Grennan",
    baseUrl: "https://tomgrennan.iyk.app",
    shopUrl: "https://store.tomgrennanmusic.com/",
  },
  meta: {
    description: "Tom Grennan",
  },
  social: [
    {
      label: "Instagram",
      logo: UI.Icon.Instagram,
      href: "https://www.instagram.com/tom.grennan/",
    },
    {
      label: "Facebook",
      logo: UI.Icon.Facebook,
      href: "https://www.facebook.com/TomGrennanMusic/",
    },
    {
      label: "YouTube",
      logo: UI.Icon.Youtube,
      href: "https://www.youtube.com/channel/UCjtK2di7aJovtPXe1m42ylA",
    },
    {
      label: "TikTok",
      logo: UI.Icon.Tiktok,
      href: "https://www.tiktok.com/@tomgrennan",
    },
    {
      label: "X",
      logo: UI.Icon.X,
      href: "https://x.com/Tom_Grennan",
    },
  ],
})

interface Config {
  appId: string
  general: {
    email: string
    name: string
    baseUrl: string
    shopUrl: string
  }
  meta: {
    description: string
  }
  social: Array<{
    label: string
    logo: React.ElementType
    href: string
  }>
}
